import * as React from 'react';
import { Button as AntButton } from 'antd';
import classNames from 'classnames';
import Icon from '../../Icon/Icon';

import './Button.scss';

type Props = {
  title?: string;
  icon?: string | React.ReactElement;
  className?: string;
  disabled?: boolean;
  isActive?: boolean;
  isLoading?: boolean;
  htmlType?: 'button' | 'reset' | 'submit';
  type?: 'link' | 'text' | 'default' | 'primary' | 'dashed';
  size?: 'large' | 'middle' | 'small';
  shape?: 'circle';
  error?: string;
  style?: React.CSSProperties;
  onClick?(e: React.MouseEvent<HTMLButtonElement>): void;
};

export default function Button(props: Props) {
  const { title, icon, htmlType, size, isActive, className, disabled, type, isLoading, onClick, error, shape, style } =
    props;

  const buttonClass = classNames('common-btn', {
    [className]: !!className,
    'common-btn--active': isActive,
  });
  const isIconString = typeof icon === 'string' || icon instanceof String;
  let buttonIcon;
  if (icon) {
    if (isIconString) {
      buttonIcon = icon ? <Icon name={icon.toString()} /> : null;
    } else {
      buttonIcon = icon;
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <AntButton
      danger={!!error}
      title={error}
      className={buttonClass}
      type={type}
      shape={shape}
      size={size}
      htmlType={htmlType || 'button'}
      icon={buttonIcon}
      loading={isLoading}
      disabled={disabled}
      style={style}
      onClick={handleClick}>
      {title}
    </AntButton>
  );
}
